var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 491,
    viewBox: "0 0 1080 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_3448)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M798.32 320.969C798.32 313.806 804.126 308.017 811.26 308.017C818.394 308.017 824.2 313.829 824.2 320.969C824.2 328.109 818.394 333.92 811.26 333.92C804.126 333.92 798.32 328.109 798.32 320.969Z",
    fill: "url(#paint0_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.08 339.799L809.91 321.127L812.385 321.127L811.08 339.799Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.215 302.43L812.385 321.125L809.91 321.125L811.215 302.43Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.47 321.057L811.148 319.886L811.148 322.363L792.47 321.057Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.826 321.17L811.148 322.363L811.148 319.886L829.826 321.17Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.585 470.863C16.585 463.701 22.3909 457.912 29.5246 457.912C36.6583 457.912 42.4643 463.723 42.4643 470.863C42.4643 478.003 36.6583 483.814 29.5246 483.814C22.3909 483.814 16.585 478.003 16.585 470.863Z",
    fill: "url(#paint1_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.345 489.693L28.1748 471.021L30.6502 471.021L29.345 489.693Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.48 452.325L30.6502 471.02L28.1748 471.02L29.48 452.325Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7341 470.951L29.4122 469.758L29.4122 472.258L10.7341 470.951Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0904 471.064L29.4122 472.258L29.4122 469.758L48.0904 471.064Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.5245 319.728C13.5245 312.566 19.3305 306.755 26.4642 306.755C33.5978 306.755 39.4038 312.566 39.4038 319.728C39.4038 326.891 33.5978 332.68 26.4642 332.68C19.3305 332.68 13.5245 326.869 13.5245 319.728Z",
    fill: "url(#paint2_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M863.739 292.926C863.739 285.763 869.545 279.952 876.679 279.952C883.812 279.952 889.618 285.763 889.618 292.926C889.618 300.088 883.812 305.877 876.679 305.877C869.545 305.877 863.739 300.066 863.739 292.926Z",
    fill: "url(#paint3_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.522 311.779L875.329 293.084L877.804 293.084L876.522 311.779Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.634 274.412L877.804 293.084L875.329 293.084L876.634 274.412Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.911 293.037L876.567 291.844L876.567 294.344L857.911 293.037Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.245 293.15L876.566 294.344L876.566 291.844L895.245 293.15Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.496 162.446C247.496 158.864 250.4 155.936 254 155.936C257.601 155.936 260.504 158.842 260.504 162.446C260.504 166.049 257.601 168.955 254 168.955C250.4 168.955 247.496 166.049 247.496 162.446Z",
    fill: "url(#paint4_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91 171.883L253.325 162.513L254.562 162.513L253.91 171.883Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.977 153.144L254.562 162.514L253.325 162.514L253.977 153.144Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.571 162.493L253.932 161.908L253.932 163.146L244.571 162.493Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.316 162.561L253.932 163.146L253.932 161.908L263.316 162.561Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M684.812 472.17C684.812 468.589 687.715 465.661 691.315 465.661C694.916 465.661 697.819 468.566 697.819 472.17C697.819 475.774 694.916 478.68 691.315 478.68C687.715 478.68 684.812 475.774 684.812 472.17Z",
    fill: "url(#paint5_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.225 481.631L690.64 472.261L691.878 472.261L691.225 481.631Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.293 462.892L691.878 472.262L690.64 472.262L691.293 462.892Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.886 472.216L691.27 471.63L691.27 472.869L681.886 472.216Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.632 472.284L691.27 472.869L691.27 471.63L700.632 472.284Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1049.35 481.539C1049.35 477.958 1052.25 475.03 1055.85 475.03C1059.45 475.03 1062.36 477.936 1062.36 481.539C1062.36 485.143 1059.45 488.049 1055.85 488.049C1052.25 488.049 1049.35 485.143 1049.35 481.539Z",
    fill: "url(#paint6_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.76 491L1055.18 481.63L1056.42 481.63L1055.76 491Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.83 472.261L1056.42 481.631L1055.18 481.631L1055.83 472.261Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.42 481.61L1055.81 481.002L1055.81 482.264L1046.42 481.61Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.17 481.656L1055.81 482.264L1055.81 481.002L1065.17 481.656Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M402.93 472.801C402.93 469.22 405.832 466.292 409.433 466.292C413.034 466.292 415.937 469.197 415.937 472.801C415.937 476.405 413.034 479.311 409.433 479.311C405.832 479.311 402.93 476.405 402.93 472.801Z",
    fill: "url(#paint7_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.343 482.238L408.758 472.868L409.995 472.868L409.343 482.238Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.41 463.499L409.995 472.869L408.758 472.869L409.41 463.499Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.004 472.849L409.388 472.263L409.388 473.502L400.004 472.849Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.749 472.916L409.388 473.502L409.388 472.263L418.749 472.916Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M824.605 356.825C824.605 353.243 827.508 350.315 831.108 350.315C834.709 350.315 837.612 353.221 837.612 356.825C837.612 360.428 834.709 363.334 831.108 363.334C827.508 363.334 824.605 360.428 824.605 356.825Z",
    fill: "url(#paint8_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.018 366.262L830.433 356.892L831.671 356.892L831.018 366.262Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.086 347.523L831.671 356.893L830.433 356.893L831.086 347.523Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.679 356.872L831.063 356.287L831.063 357.525L821.679 356.872Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.425 356.94L831.063 357.525L831.063 356.287L840.425 356.94Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.8642 366.198C54.8642 362.616 57.7673 359.688 61.3679 359.688C64.9685 359.688 67.8714 362.594 67.8714 366.198C67.8714 369.801 64.9685 372.707 61.3679 372.707C57.7673 372.707 54.8642 369.801 54.8642 366.198Z",
    fill: "url(#paint9_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2775 375.656L60.6924 366.264L61.9301 366.264L61.2775 375.656Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.345 356.894L61.9301 366.264L60.6924 366.264L61.345 356.894Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9611 366.241L61.3226 365.656L61.3226 366.895L51.9611 366.241Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6841 366.309L61.3226 366.895L61.3226 365.656L70.6841 366.309Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.92551 45.0961C2.92551 41.5148 5.82846 38.5867 9.42906 38.5867C13.0297 38.5867 15.9327 41.4922 15.9327 45.0961C15.9327 48.6999 13.0297 51.6055 9.42906 51.6055C5.82846 51.6055 2.92551 48.6999 2.92551 45.0961Z",
    fill: "url(#paint10_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33908 54.5566L8.73143 45.1867L9.99164 45.1867L9.33908 54.5566Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38406 35.8176L9.99164 45.1875L8.73143 45.1875L9.38406 35.8176Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000125942 45.1671L9.36169 44.5589L9.36169 45.8203L0.000125942 45.1671Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7232 45.2122L9.36164 45.8203L9.36164 44.5589L18.7232 45.2122Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M977.315 73.1625C977.315 69.5812 980.218 66.6531 983.819 66.6531C987.42 66.6531 990.323 69.5586 990.323 73.1625C990.323 76.7663 987.42 79.6719 983.819 79.6719C980.218 79.6719 977.315 76.7663 977.315 73.1625Z",
    fill: "url(#paint11_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.707 82.623L983.122 73.2531L984.359 73.2531L983.707 82.623Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.774 63.884L984.359 73.2539L983.122 73.2539L983.774 63.884Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.39 73.2081L983.752 72.6225L983.752 73.8613L974.39 73.2081Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.113 73.2757L983.752 73.8613L983.752 72.6225L993.113 73.2757Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M970.857 398.967C970.857 395.386 973.76 392.458 977.36 392.458C980.961 392.458 983.864 395.363 983.864 398.967C983.864 402.571 980.961 405.477 977.36 405.477C973.76 405.477 970.857 402.571 970.857 398.967Z",
    fill: "url(#paint12_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.27 408.426L976.685 399.056L977.923 399.056L977.27 408.426Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.338 389.687L977.923 399.057L976.685 399.057L977.338 389.687Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.931 399.011L977.315 398.425L977.315 399.664L967.931 399.011Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.677 399.078L977.315 399.664L977.315 398.425L986.677 399.078Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M560.793 318.555C560.793 314.974 563.696 312.046 567.297 312.046C570.897 312.046 573.8 314.951 573.8 318.555C573.8 322.159 570.897 325.064 567.297 325.064C563.696 325.064 560.793 322.159 560.793 318.555Z",
    fill: "url(#paint13_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.184 327.994L566.599 318.624L567.837 318.624L567.184 327.994Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.252 309.255L567.837 318.625L566.599 318.625L567.252 309.255Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.868 318.605L567.229 318.019L567.229 319.258L557.868 318.605Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.591 318.672L567.229 319.258L567.229 318.019L576.591 318.672Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M200.846 399.598C200.846 396.017 203.749 393.089 207.35 393.089C210.95 393.089 213.853 395.994 213.853 399.598C213.853 403.202 210.95 406.107 207.35 406.107C203.749 406.107 200.846 403.202 200.846 399.598Z",
    fill: "url(#paint14_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.26 409.037L206.652 399.667L207.912 399.667L207.26 409.037Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.305 390.298L207.912 399.668L206.652 399.668L207.305 390.298Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.921 399.648L207.282 399.062L207.282 400.301L197.921 399.648Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.644 399.715L207.282 400.301L207.282 399.062L216.644 399.715Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.583 327.928C380.583 324.347 383.486 321.419 387.087 321.419C390.687 321.419 393.59 324.324 393.59 327.928C393.59 331.532 390.687 334.437 387.087 334.437C383.486 334.437 380.583 331.532 380.583 327.928Z",
    fill: "url(#paint15_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.974 337.387L386.389 327.994L387.627 327.994L386.974 337.387Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.042 318.624L387.627 327.994L386.389 327.994L387.042 318.624Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.658 327.972L387.019 327.386L387.019 328.625L377.658 327.972Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.381 328.039L387.019 328.625L387.019 327.386L396.381 328.039Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.1834 420.252C50.1834 416.671 53.0863 413.743 56.6869 413.743C60.2875 413.743 63.1906 416.648 63.1906 420.252C63.1906 423.856 60.2875 426.762 56.6869 426.762C53.0863 426.762 50.1834 423.856 50.1834 420.252Z",
    fill: "url(#paint16_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5969 429.711L56.0118 420.318L57.2495 420.318L56.5969 429.711Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6644 410.948L57.2495 420.318L56.0118 420.318L56.6644 410.948Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2578 420.296L56.6419 419.71L56.6419 420.949L47.2578 420.296Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0035 420.364L56.6419 420.949L56.6419 419.71L66.0035 420.364Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M467.29 63.6991C467.29 56.5366 473.096 50.7479 480.23 50.7479C487.363 50.7479 493.169 56.5591 493.169 63.6992C493.169 70.8392 487.363 76.6504 480.23 76.6504C473.096 76.6504 467.29 70.8392 467.29 63.6991Z",
    fill: "url(#paint17_radial_172_3448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.072 82.5508L478.88 63.8785L481.377 63.8785L480.072 82.5508Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.185 45.1821L481.377 63.877L478.88 63.877L480.185 45.1821Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.462 63.8088L480.14 62.6151L480.14 65.1152L461.462 63.8088Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.795 63.9215L480.14 65.1152L480.14 62.6151L498.795 63.9215Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.898 183.999C991.898 183.323 992.438 182.782 993.113 182.782C993.788 182.782 994.328 183.323 994.328 183.999C994.328 184.674 993.788 185.215 993.113 185.215C992.438 185.215 991.898 184.674 991.898 183.999Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.475 115.211C915.475 114.536 916.015 113.995 916.69 113.995C917.365 113.995 917.905 114.536 917.905 115.211C917.905 115.887 917.365 116.428 916.69 116.428C916.015 116.428 915.475 115.887 915.475 115.211Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.266 198.547C847.266 197.872 847.806 197.331 848.481 197.331C849.156 197.331 849.697 197.872 849.697 198.547C849.697 199.223 849.156 199.764 848.481 199.764C847.806 199.764 847.266 199.223 847.266 198.547Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.845 54.5298C660.845 53.8541 661.385 53.3135 662.061 53.3135C662.736 53.3135 663.276 53.8541 663.276 54.5298C663.276 55.2055 662.736 55.7461 662.061 55.7461C661.385 55.7461 660.845 55.2055 660.845 54.5298Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.63 421.538C659.63 420.862 660.17 420.321 660.845 420.321C661.52 420.321 662.06 420.862 662.06 421.538C662.06 422.213 661.52 422.754 660.845 422.754C660.17 422.754 659.63 422.213 659.63 421.538Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.652 230.083C508.652 229.407 509.192 228.866 509.867 228.866C510.542 228.866 511.083 229.407 511.083 230.083C511.083 230.758 510.542 231.299 509.867 231.299C509.192 231.299 508.652 230.758 508.652 230.083Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.311 302.43C442.311 301.754 442.851 301.214 443.527 301.214C444.202 301.214 444.742 301.754 444.742 302.43C444.742 303.106 444.202 303.646 443.527 303.646C442.851 303.646 442.311 303.106 442.311 302.43Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.538 231.301C380.538 230.626 381.078 230.085 381.753 230.085C382.429 230.085 382.969 230.626 382.969 231.301C382.969 231.977 382.429 232.518 381.753 232.518C381.078 232.518 380.538 231.977 380.538 231.301Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.318 398.428C471.318 397.753 471.858 397.212 472.534 397.212C473.209 397.212 473.749 397.753 473.749 398.428C473.749 399.104 473.209 399.645 472.534 399.645C471.858 399.645 471.318 399.104 471.318 398.428Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.889 422.754C413.889 422.079 414.429 421.538 415.104 421.538C415.779 421.538 416.319 422.079 416.319 422.754C416.319 423.43 415.779 423.971 415.104 423.971C414.429 423.971 413.889 423.43 413.889 422.754Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.889 438.631C429.889 437.956 430.429 437.415 431.104 437.415C431.779 437.415 432.319 437.956 432.319 438.631C432.319 439.307 431.779 439.848 431.104 439.848C430.429 439.848 429.889 439.307 429.889 438.631Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.534 429.688C472.534 429.012 473.074 428.472 473.749 428.472C474.424 428.472 474.964 429.012 474.964 429.688C474.964 430.364 474.424 430.904 473.749 430.904C473.074 430.904 472.534 430.364 472.534 429.688Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.929 371.579C338.929 370.903 339.469 370.362 340.144 370.362C340.819 370.362 341.359 370.903 341.359 371.579C341.359 372.254 340.819 372.795 340.144 372.795C339.469 372.795 338.929 372.254 338.929 371.579Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.059 429.688C264.059 429.012 264.599 428.472 265.274 428.472C265.949 428.472 266.49 429.012 266.49 429.688C266.49 430.364 265.949 430.904 265.274 430.904C264.599 430.904 264.059 430.364 264.059 429.688Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.723 367.479C105.723 366.803 106.263 366.263 106.938 366.263C107.613 366.263 108.153 366.803 108.153 367.479C108.153 368.155 107.613 368.695 106.938 368.695C106.263 368.695 105.723 368.155 105.723 367.479Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9178 451.11C76.9178 450.434 77.4578 449.894 78.1329 449.894C78.808 449.894 79.3481 450.434 79.3481 451.11C79.3481 451.786 78.808 452.326 78.1329 452.326C77.4578 452.326 76.9178 451.786 76.9178 451.11Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.449 370.362C666.449 369.686 666.989 369.146 667.664 369.146C668.339 369.146 668.879 369.686 668.879 370.362C668.879 371.038 668.339 371.578 667.664 371.578C666.989 371.578 666.449 371.038 666.449 370.362Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.945 29.6196C405.945 29.3268 406.192 29.079 406.485 29.079C406.777 29.079 407.025 29.3268 407.025 29.6196C407.025 29.9124 406.777 30.1602 406.485 30.1602C406.192 30.1602 405.945 29.9124 405.945 29.6196Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.034 139.424C397.034 139.131 397.281 138.884 397.574 138.884C397.866 138.884 398.114 139.131 398.114 139.424C398.114 139.717 397.866 139.965 397.574 139.965C397.281 139.965 397.034 139.717 397.034 139.424Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23 116.811C313.23 116.518 313.477 116.27 313.77 116.27C314.062 116.27 314.31 116.518 314.31 116.811C314.31 117.104 314.062 117.352 313.77 117.352C313.477 117.352 313.23 117.104 313.23 116.811Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.915 167.67C582.915 167.378 583.162 167.13 583.455 167.13C583.747 167.13 583.995 167.378 583.995 167.67C583.995 167.963 583.747 168.211 583.455 168.211C583.162 168.211 582.915 167.963 582.915 167.67Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.909 79.6684C427.909 79.3756 428.156 79.1278 428.449 79.1278C428.741 79.1278 428.989 79.3756 428.989 79.6684C428.989 79.9612 428.741 80.209 428.449 80.209C428.156 80.209 427.909 79.9612 427.909 79.6684Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.84 228.868C434.84 228.575 435.088 228.327 435.38 228.327C435.673 228.327 435.92 228.575 435.92 228.868C435.92 229.16 435.673 229.408 435.38 229.408C435.088 229.408 434.84 229.16 434.84 228.868Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.498 461.336C510.498 461.044 510.745 460.796 511.038 460.796C511.33 460.796 511.578 461.044 511.578 461.336C511.578 461.629 511.33 461.877 511.038 461.877C510.745 461.877 510.498 461.629 510.498 461.336Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.871 451.112C591.871 450.819 592.119 450.571 592.411 450.571C592.704 450.571 592.951 450.819 592.951 451.112C592.951 451.405 592.704 451.652 592.411 451.652C592.119 451.652 591.871 451.405 591.871 451.112Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.387 470.502C885.387 470.21 885.635 469.962 885.927 469.962C886.22 469.962 886.468 470.21 886.468 470.502C886.468 470.795 886.22 471.043 885.927 471.043C885.635 471.043 885.387 470.795 885.387 470.502Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.704 430.907C894.704 430.614 894.952 430.366 895.244 430.366C895.537 430.366 895.784 430.614 895.784 430.907C895.784 431.2 895.537 431.447 895.244 431.447C894.952 431.447 894.704 431.2 894.704 430.907Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6359 256.864C20.6359 256.571 20.8834 256.323 21.1759 256.323C21.4685 256.323 21.7161 256.571 21.7161 256.864C21.7161 257.157 21.4685 257.404 21.1759 257.404C20.8834 257.404 20.6359 257.157 20.6359 256.864Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.996 290.629C52.996 290.337 53.2436 290.089 53.5361 290.089C53.8287 290.089 54.0762 290.337 54.0762 290.629C54.0762 290.922 53.8287 291.17 53.5361 291.17C53.2436 291.17 52.996 290.922 52.996 290.629Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.424 279.975C609.424 279.682 609.672 279.434 609.964 279.434C610.257 279.434 610.504 279.682 610.504 279.975C610.504 280.268 610.257 280.516 609.964 280.516C609.672 280.516 609.424 280.268 609.424 279.975Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.815 25.9927C933.815 25.6998 934.063 25.4521 934.355 25.4521C934.648 25.4521 934.896 25.6998 934.896 25.9927C934.896 26.2855 934.648 26.5332 934.355 26.5332C934.063 26.5332 933.815 26.2855 933.815 25.9927Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.265 332.68C664.265 332.387 664.513 332.14 664.805 332.14C665.098 332.14 665.346 332.387 665.346 332.68C665.346 332.973 665.098 333.221 664.805 333.221C664.513 333.221 664.265 332.973 664.265 332.68Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.728 392.457C617.728 392.165 617.975 391.917 618.268 391.917C618.561 391.917 618.808 392.165 618.808 392.457C618.808 392.75 618.561 392.998 618.268 392.998C617.975 392.998 617.728 392.75 617.728 392.457Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.077 389.145C722.077 388.852 722.325 388.604 722.618 388.604C722.91 388.604 723.158 388.852 723.158 389.145C723.158 389.438 722.91 389.686 722.618 389.686C722.325 389.686 722.077 389.438 722.077 389.145Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.429 350.317C732.429 350.024 732.677 349.776 732.97 349.776C733.262 349.776 733.51 350.024 733.51 350.317C733.51 350.61 733.262 350.857 732.97 350.857C732.677 350.857 732.429 350.61 732.429 350.317Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.56 334.436C1023.56 334.143 1023.81 333.895 1024.1 333.895C1024.39 333.895 1024.64 334.143 1024.64 334.436C1024.64 334.729 1024.39 334.977 1024.1 334.977C1023.81 334.977 1023.56 334.729 1023.56 334.436Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.64 275.85C1024.64 275.557 1024.89 275.309 1025.18 275.309C1025.47 275.309 1025.72 275.557 1025.72 275.85C1025.72 276.143 1025.47 276.391 1025.18 276.391C1024.89 276.391 1024.64 276.143 1024.64 275.85Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.398 171.881C106.398 171.589 106.645 171.341 106.938 171.341C107.23 171.341 107.478 171.589 107.478 171.881C107.478 172.174 107.23 172.422 106.938 172.422C106.645 172.422 106.398 172.174 106.398 171.881Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1849 230.082C91.1849 229.79 91.4325 229.542 91.725 229.542C92.0176 229.542 92.2651 229.79 92.2651 230.082C92.2651 230.375 92.0176 230.623 91.725 230.623C91.4325 230.623 91.1849 230.375 91.1849 230.082Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.582 290.11C117.582 289.817 117.83 289.569 118.122 289.569C118.415 289.569 118.662 289.817 118.662 290.11C118.662 290.403 118.415 290.65 118.122 290.65C117.83 290.65 117.582 290.403 117.582 290.11Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9221 319.256C71.9221 318.963 72.1696 318.716 72.4622 318.716C72.7547 318.716 73.0023 318.963 73.0023 319.256C73.0023 319.549 72.7547 319.797 72.4622 319.797C72.1696 319.797 71.9221 319.549 71.9221 319.256Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.734 478.95C248.734 478.657 248.981 478.409 249.274 478.409C249.566 478.409 249.814 478.657 249.814 478.95C249.814 479.242 249.566 479.49 249.274 479.49C248.981 479.49 248.734 479.242 248.734 478.95Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.445 483.276C211.445 482.983 211.693 482.735 211.985 482.735C212.278 482.735 212.525 482.983 212.525 483.276C212.525 483.569 212.278 483.816 211.985 483.816C211.693 483.816 211.445 483.569 211.445 483.276Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 344.211C125.008 343.919 125.256 343.671 125.548 343.671C125.841 343.671 126.088 343.919 126.088 344.211C126.088 344.504 125.841 344.752 125.548 344.752C125.256 344.752 125.008 344.504 125.008 344.211Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 388.608C126.921 388.315 127.168 388.067 127.461 388.067C127.753 388.067 128.001 388.315 128.001 388.608C128.001 388.901 127.753 389.148 127.461 389.148C127.168 389.148 126.921 388.901 126.921 388.608Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.148 363.313C152.148 363.02 152.395 362.772 152.688 362.772C152.98 362.772 153.228 363.02 153.228 363.313C153.228 363.606 152.98 363.854 152.688 363.854C152.395 363.854 152.148 363.606 152.148 363.313Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.712 313.942C312.712 313.649 312.959 313.401 313.252 313.401C313.545 313.401 313.792 313.649 313.792 313.942C313.792 314.235 313.545 314.482 313.252 314.482C312.959 314.482 312.712 314.235 312.712 313.942Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.481 338.581C308.481 338.288 308.729 338.04 309.021 338.04C309.314 338.04 309.562 338.288 309.562 338.581C309.562 338.873 309.314 339.121 309.021 339.121C308.729 339.121 308.481 338.873 308.481 338.581Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.519 307.993C279.519 307.7 279.766 307.452 280.059 307.452C280.352 307.452 280.599 307.7 280.599 307.993C280.599 308.285 280.352 308.533 280.059 308.533C279.766 308.533 279.519 308.285 279.519 307.993Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.949 341.012C281.949 340.719 282.197 340.472 282.489 340.472C282.782 340.472 283.03 340.719 283.03 341.012C283.03 341.305 282.782 341.553 282.489 341.553C282.197 341.553 281.949 341.305 281.949 341.012Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.035 274.409C303.035 274.116 303.283 273.868 303.575 273.868C303.868 273.868 304.115 274.116 304.115 274.409C304.115 274.701 303.868 274.949 303.575 274.949C303.283 274.949 303.035 274.701 303.035 274.409Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.521 316.935C352.521 316.8 352.634 316.665 352.791 316.665C352.949 316.665 353.061 316.777 353.061 316.935C353.061 317.092 352.949 317.205 352.791 317.205C352.634 317.205 352.521 317.092 352.521 316.935Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.039 368.693C314.039 368.557 314.152 368.422 314.309 368.422C314.467 368.422 314.58 368.535 314.58 368.693C314.58 368.85 314.467 368.963 314.309 368.963C314.152 368.963 314.039 368.85 314.039 368.693Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.442 350.316C312.442 350.158 312.555 350.045 312.712 350.045C312.87 350.045 312.982 350.158 312.982 350.316C312.982 350.473 312.87 350.586 312.712 350.586C312.555 350.586 312.442 350.473 312.442 350.316Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.49 199.765C600.49 199.63 600.602 199.495 600.76 199.495C600.917 199.495 601.03 199.607 601.03 199.765C601.03 199.923 600.917 200.035 600.76 200.035C600.602 200.035 600.49 199.923 600.49 199.765Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.196 446.9C170.196 446.764 170.308 446.629 170.466 446.629C170.623 446.629 170.736 446.742 170.736 446.9C170.736 447.057 170.623 447.17 170.466 447.17C170.308 447.17 170.196 447.057 170.196 446.9Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.473 472.866C183.473 472.731 183.586 472.596 183.743 472.596C183.901 472.596 184.013 472.709 184.013 472.866C184.013 473.024 183.901 473.137 183.743 473.137C183.586 473.137 183.473 473.024 183.473 472.866Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.815 437.415C146.815 437.28 146.927 437.145 147.085 437.145C147.242 437.145 147.355 437.258 147.355 437.415C147.355 437.573 147.242 437.686 147.085 437.686C146.927 437.686 146.815 437.573 146.815 437.415Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.709 479.31C127.709 479.152 127.821 479.04 127.979 479.04C128.136 479.04 128.249 479.152 128.249 479.31C128.249 479.467 128.136 479.58 127.979 479.58C127.821 479.58 127.709 479.467 127.709 479.31Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.716 460.794C291.716 460.659 291.829 460.524 291.986 460.524C292.144 460.524 292.256 460.636 292.256 460.794C292.256 460.952 292.144 461.064 291.986 461.064C291.829 461.064 291.716 460.952 291.716 460.794Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.013 483.275C271.013 483.139 271.125 483.004 271.283 483.004C271.44 483.004 271.553 483.117 271.553 483.275C271.553 483.432 271.44 483.545 271.283 483.545C271.125 483.545 271.013 483.432 271.013 483.275Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7334 469.759C65.7334 469.624 65.8459 469.489 66.0035 469.489C66.161 469.489 66.2735 469.601 66.2735 469.759C66.2735 469.917 66.161 470.029 66.0035 470.029C65.8459 470.029 65.7334 469.917 65.7334 469.759Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4223 488.05C60.4223 487.915 60.5348 487.78 60.6924 487.78C60.8499 487.78 60.9625 487.892 60.9625 488.05C60.9625 488.208 60.8499 488.32 60.6924 488.32C60.5348 488.32 60.4223 488.208 60.4223 488.05Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2944 449.894C57.2944 449.759 57.4069 449.623 57.5644 449.623C57.722 449.623 57.8345 449.736 57.8345 449.894C57.8345 450.051 57.722 450.164 57.5644 450.164C57.4069 450.164 57.2944 450.051 57.2944 449.894Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.859 428.497C114.859 428.362 114.972 428.227 115.129 428.227C115.287 428.227 115.399 428.34 115.399 428.497C115.399 428.655 115.287 428.768 115.129 428.768C114.972 428.768 114.859 428.655 114.859 428.497Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.724 279.974C217.724 279.839 217.836 279.704 217.994 279.704C218.151 279.704 218.264 279.816 218.264 279.974C218.264 280.132 218.151 280.244 217.994 280.244C217.836 280.244 217.724 280.132 217.724 279.974Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 307.476C215.856 307.341 215.968 307.206 216.126 307.206C216.283 307.206 216.396 307.318 216.396 307.476C216.396 307.633 216.283 307.746 216.126 307.746C215.968 307.746 215.856 307.633 215.856 307.476Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.233 279.974C260.233 279.839 260.346 279.704 260.503 279.704C260.661 279.704 260.773 279.816 260.773 279.974C260.773 280.132 260.661 280.244 260.503 280.244C260.346 280.244 260.233 280.132 260.233 279.974Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.251 210.823C352.251 210.688 352.364 210.553 352.521 210.553C352.679 210.553 352.791 210.666 352.791 210.823C352.791 210.981 352.679 211.094 352.521 211.094C352.364 211.094 352.251 210.981 352.251 210.823Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.521 200.036C368.521 199.901 368.634 199.766 368.791 199.766C368.949 199.766 369.061 199.879 369.061 200.036C369.061 200.194 368.949 200.307 368.791 200.307C368.634 200.307 368.521 200.194 368.521 200.036Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.79 172.423C375.79 172.288 375.903 172.153 376.06 172.153C376.218 172.153 376.33 172.265 376.33 172.423C376.33 172.581 376.218 172.693 376.06 172.693C375.903 172.693 375.79 172.581 375.79 172.423Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.98 176.521C422.98 176.386 423.093 176.25 423.25 176.25C423.408 176.25 423.52 176.363 423.52 176.521C423.52 176.678 423.408 176.791 423.25 176.791C423.093 176.791 422.98 176.678 422.98 176.521Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.462 236.568C358.462 236.432 358.575 236.297 358.732 236.297C358.89 236.297 359.002 236.41 359.002 236.568C359.002 236.725 358.89 236.838 358.732 236.838C358.575 236.838 358.462 236.725 358.462 236.568Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.462 138.907C358.462 138.75 358.575 138.637 358.732 138.637C358.89 138.637 359.002 138.75 359.002 138.907C359.002 139.065 358.89 139.178 358.732 139.178C358.575 139.178 358.462 139.065 358.462 138.907Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.463 153.142C319.463 153.007 319.576 152.872 319.733 152.872C319.891 152.872 320.003 152.984 320.003 153.142C320.003 153.3 319.891 153.412 319.733 153.412C319.576 153.412 319.463 153.3 319.463 153.142Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.765 193.64C302.765 193.505 302.878 193.37 303.035 193.37C303.193 193.37 303.305 193.482 303.305 193.64C303.305 193.798 303.193 193.91 303.035 193.91C302.878 193.91 302.765 193.798 302.765 193.64Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.743 65.1164C183.743 64.9813 183.855 64.8462 184.013 64.8462C184.171 64.8462 184.283 64.9588 184.283 65.1164C184.283 65.2741 184.171 65.3867 184.013 65.3867C183.855 65.3867 183.743 65.2741 183.743 65.1164Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.483 75.4563C754.483 75.3211 754.596 75.186 754.753 75.186C754.911 75.186 755.023 75.2986 755.023 75.4563C755.023 75.6139 754.911 75.7266 754.753 75.7266C754.596 75.7266 754.483 75.6139 754.483 75.4563Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.936 104.718C740.936 104.583 741.048 104.448 741.206 104.448C741.363 104.448 741.476 104.56 741.476 104.718C741.476 104.876 741.363 104.988 741.206 104.988C741.048 104.988 740.936 104.876 740.936 104.718Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.044 86.1555C730.044 86.0203 730.157 85.8852 730.314 85.8852C730.472 85.8852 730.584 85.9978 730.584 86.1555C730.584 86.3131 730.472 86.4258 730.314 86.4258C730.157 86.4258 730.044 86.3131 730.044 86.1555Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.537 145.439C792.537 145.304 792.649 145.168 792.807 145.168C792.965 145.168 793.077 145.281 793.077 145.439C793.077 145.596 792.965 145.709 792.807 145.709C792.649 145.709 792.537 145.596 792.537 145.439Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.557 222.179C790.557 222.044 790.669 221.909 790.827 221.909C790.985 221.909 791.097 222.021 791.097 222.179C791.097 222.337 790.985 222.449 790.827 222.449C790.669 222.449 790.557 222.337 790.557 222.179Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.398 196.273C813.398 196.138 813.51 196.002 813.668 196.002C813.825 196.002 813.938 196.115 813.938 196.273C813.938 196.43 813.825 196.543 813.668 196.543C813.51 196.543 813.398 196.43 813.398 196.273Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.798 186.05C706.798 185.892 706.91 185.78 707.068 185.78C707.225 185.78 707.338 185.892 707.338 186.05C707.338 186.208 707.225 186.32 707.068 186.32C706.91 186.32 706.798 186.208 706.798 186.05Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.306 12.9739C422.306 12.8162 422.418 12.7036 422.576 12.7036C422.733 12.7036 422.846 12.8162 422.846 12.9739C422.846 13.1315 422.733 13.2441 422.576 13.2441C422.418 13.2441 422.306 13.1315 422.306 12.9739Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.922 422.753C492.922 422.618 493.034 422.483 493.192 422.483C493.349 422.483 493.462 422.595 493.462 422.753C493.462 422.911 493.349 423.023 493.192 423.023C493.034 423.023 492.922 422.911 492.922 422.753Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.883 128.525C107.883 128.39 107.995 128.254 108.153 128.254C108.311 128.254 108.423 128.367 108.423 128.525C108.423 128.682 108.311 128.795 108.153 128.795C107.995 128.795 107.883 128.682 107.883 128.525Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9149 150.009C90.9149 149.874 91.0275 149.739 91.185 149.739C91.3425 149.739 91.455 149.851 91.455 150.009C91.455 150.167 91.3425 150.279 91.185 150.279C91.0275 150.279 90.9149 150.167 90.9149 150.009Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.393 255.962C182.393 255.827 182.506 255.692 182.663 255.692C182.821 255.692 182.933 255.804 182.933 255.962C182.933 256.12 182.821 256.232 182.663 256.232C182.506 256.232 182.393 256.12 182.393 255.962Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7334 258.779C65.7334 258.643 65.8459 258.508 66.0035 258.508C66.161 258.508 66.2735 258.621 66.2735 258.779C66.2735 258.936 66.161 259.049 66.0035 259.049C65.8459 259.049 65.7334 258.936 65.7334 258.779Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6451 389.15C90.6451 389.014 90.7577 388.879 90.9152 388.879C91.0727 388.879 91.1852 388.992 91.1852 389.15C91.1852 389.307 91.0727 389.42 90.9152 389.42C90.7577 389.42 90.6451 389.307 90.6451 389.15Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.452 410.948C105.452 410.813 105.565 410.678 105.722 410.678C105.88 410.678 105.992 410.791 105.992 410.948C105.992 411.106 105.88 411.219 105.722 411.219C105.565 411.219 105.452 411.106 105.452 410.948Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.727 478.681C164.727 478.546 164.84 478.411 164.997 478.411C165.155 478.411 165.267 478.523 165.267 478.681C165.267 478.839 165.155 478.951 164.997 478.951C164.84 478.951 164.727 478.839 164.727 478.681Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.986 431.448C291.986 431.155 292.233 430.907 292.526 430.907C292.819 430.907 293.066 431.155 293.066 431.448C293.066 431.741 292.819 431.988 292.526 431.988C292.233 431.988 291.986 431.741 291.986 431.448Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.769 416.176C352.769 415.883 353.016 415.636 353.309 415.636C353.601 415.636 353.849 415.883 353.849 416.176C353.849 416.469 353.601 416.717 353.309 416.717C353.016 416.717 352.769 416.469 352.769 416.176Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.13 468.184C362.13 467.891 362.378 467.643 362.67 467.643C362.963 467.643 363.21 467.891 363.21 468.184C363.21 468.477 362.963 468.725 362.67 468.725C362.378 468.725 362.13 468.477 362.13 468.184Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.051 483.813C457.051 483.52 457.299 483.272 457.591 483.272C457.884 483.272 458.131 483.52 458.131 483.813C458.131 484.106 457.884 484.354 457.591 484.354C457.299 484.354 457.051 484.106 457.051 483.813Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6343 388.088C27.6343 387.796 27.8819 387.548 28.1744 387.548C28.467 387.548 28.7145 387.796 28.7145 388.088C28.7145 388.381 28.467 388.629 28.1744 388.629C27.8819 388.629 27.6343 388.381 27.6343 388.088Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2053 198.547C18.2053 198.255 18.4528 198.007 18.7453 198.007C19.0379 198.007 19.2854 198.255 19.2854 198.547C19.2854 198.84 19.0379 199.088 18.7453 199.088C18.4528 199.088 18.2053 198.84 18.2053 198.547Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.917 221.661C163.917 221.368 164.165 221.12 164.457 221.12C164.75 221.12 164.997 221.368 164.997 221.661C164.997 221.953 164.75 222.201 164.457 222.201C164.165 222.201 163.917 221.953 163.917 221.661Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4211 12.436C51.4211 12.1432 51.6687 11.8954 51.9612 11.8954C52.2538 11.8954 52.5013 12.1432 52.5013 12.436C52.5013 12.7288 52.2538 12.9766 51.9612 12.9766C51.6687 12.9766 51.4211 12.7288 51.4211 12.436Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3802 55.7485C46.3802 55.4557 46.6277 55.2079 46.9203 55.2079C47.2128 55.2079 47.4604 55.4557 47.4604 55.7485C47.4604 56.0413 47.2128 56.2891 46.9203 56.2891C46.6277 56.2891 46.3802 56.0413 46.3802 55.7485Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6442 100.413C10.6442 100.12 10.8917 99.872 11.1843 99.872C11.4768 99.872 11.7244 100.12 11.7244 100.413C11.7244 100.705 11.4768 100.953 11.1843 100.953C10.8917 100.953 10.6442 100.705 10.6442 100.413Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.505 6.26215C102.505 5.96934 102.752 5.7216 103.045 5.7216C103.337 5.7216 103.585 5.96934 103.585 6.26215C103.585 6.55496 103.337 6.80273 103.045 6.80273C102.752 6.80273 102.505 6.55496 102.505 6.26215Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9454 100.956C32.9454 100.663 33.1929 100.415 33.4854 100.415C33.778 100.415 34.0256 100.663 34.0256 100.956C34.0256 101.248 33.778 101.496 33.4854 101.496C33.1929 101.496 32.9454 101.248 32.9454 100.956Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.831 6.26215C229.831 5.96934 230.079 5.7216 230.371 5.7216C230.664 5.7216 230.911 5.96934 230.911 6.26215C230.911 6.55496 230.664 6.80273 230.371 6.80273C230.079 6.80273 229.831 6.55496 229.831 6.26215Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.643 68.5649C216.643 68.2721 216.891 68.0243 217.184 68.0243C217.476 68.0243 217.724 68.2721 217.724 68.5649C217.724 68.8577 217.476 69.1055 217.184 69.1055C216.891 69.1055 216.643 68.8577 216.643 68.5649Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86 30.1606C162.86 29.8678 163.107 29.62 163.4 29.62C163.692 29.62 163.94 29.8678 163.94 30.1606C163.94 30.4534 163.692 30.7012 163.4 30.7012C163.107 30.7012 162.86 30.4534 162.86 30.1606Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.066 21.311C579.066 21.0182 579.314 20.7704 579.607 20.7704C579.899 20.7704 580.147 21.0182 580.147 21.311C580.147 21.6038 579.899 21.8516 579.607 21.8516C579.314 21.8516 579.066 21.6038 579.066 21.311Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.802 12.9751C614.802 12.6823 615.05 12.4345 615.343 12.4345C615.635 12.4345 615.883 12.6823 615.883 12.9751C615.883 13.2679 615.635 13.5156 615.343 13.5156C615.05 13.5156 614.802 13.2679 614.802 12.9751Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.306 195.758C200.306 195.465 200.553 195.218 200.846 195.218C201.138 195.218 201.386 195.465 201.386 195.758C201.386 196.051 201.138 196.299 200.846 196.299C200.553 196.299 200.306 196.051 200.306 195.758Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.789 472.26C787.789 471.967 788.036 471.72 788.329 471.72C788.621 471.72 788.869 471.967 788.869 472.26C788.869 472.553 788.621 472.801 788.329 472.801C788.036 472.801 787.789 472.553 787.789 472.26Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.264 441.807C742.264 441.514 742.511 441.267 742.804 441.267C743.096 441.267 743.344 441.514 743.344 441.807C743.344 442.1 743.096 442.348 742.804 442.348C742.511 442.348 742.264 442.1 742.264 441.807Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.932 465.663C253.932 465.37 254.18 465.122 254.472 465.122C254.765 465.122 255.012 465.37 255.012 465.663C255.012 465.955 254.765 466.203 254.472 466.203C254.18 466.203 253.932 465.955 253.932 465.663Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.084 467.575C147.084 467.282 147.332 467.034 147.624 467.034C147.917 467.034 148.164 467.282 148.164 467.575C148.164 467.867 147.917 468.115 147.624 468.115C147.332 468.115 147.084 467.867 147.084 467.575Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 408.426C163.4 408.133 163.647 407.886 163.94 407.886C164.232 407.886 164.48 408.133 164.48 408.426C164.48 408.719 164.232 408.967 163.94 408.967C163.647 408.967 163.4 408.719 163.4 408.426Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.609 480.998C636.609 480.706 636.856 480.458 637.149 480.458C637.441 480.458 637.689 480.706 637.689 480.998C637.689 481.291 637.441 481.539 637.149 481.539C636.856 481.539 636.609 481.291 636.609 480.998Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.603 475.053C950.603 474.76 950.851 474.513 951.143 474.513C951.436 474.513 951.683 474.76 951.683 475.053C951.683 475.346 951.436 475.594 951.143 475.594C950.851 475.594 950.603 475.346 950.603 475.053Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.19 423.969C1070.19 423.676 1070.44 423.429 1070.73 423.429C1071.02 423.429 1071.27 423.676 1071.27 423.969C1071.27 424.262 1071.02 424.51 1070.73 424.51C1070.44 424.51 1070.19 424.262 1070.19 423.969Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.56 389.688C1023.56 389.395 1023.81 389.147 1024.1 389.147C1024.39 389.147 1024.64 389.395 1024.64 389.688C1024.64 389.981 1024.39 390.229 1024.1 390.229C1023.81 390.229 1023.56 389.981 1023.56 389.688Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.663 128.524C182.663 128.231 182.91 127.983 183.203 127.983C183.495 127.983 183.743 128.231 183.743 128.524C183.743 128.817 183.495 129.064 183.203 129.064C182.91 129.064 182.663 128.817 182.663 128.524Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.209 165.934C608.209 165.641 608.456 165.393 608.749 165.393C609.042 165.393 609.289 165.641 609.289 165.934C609.289 166.227 609.042 166.475 608.749 166.475C608.456 166.475 608.209 166.227 608.209 165.934Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.306 40.0708C200.306 39.778 200.553 39.5302 200.846 39.5302C201.138 39.5302 201.386 39.778 201.386 40.0708C201.386 40.3636 201.138 40.6113 200.846 40.6113C200.553 40.6113 200.306 40.3636 200.306 40.0708Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87 85.6137C193.87 85.3209 194.117 85.0732 194.41 85.0732C194.702 85.0732 194.95 85.3209 194.95 85.6137C194.95 85.9066 194.702 86.1543 194.41 86.1543C194.117 86.1543 193.87 85.9066 193.87 85.6137Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.157 7.32074C762.157 7.02793 762.405 6.78019 762.697 6.78019C762.99 6.78019 763.237 7.02793 763.237 7.32074C763.237 7.61355 762.99 7.86133 762.697 7.86133C762.405 7.86133 762.157 7.61355 762.157 7.32074Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.706 143.973C681.706 143.68 681.954 143.433 682.246 143.433C682.539 143.433 682.786 143.68 682.786 143.973C682.786 144.266 682.539 144.514 682.246 144.514C681.954 144.514 681.706 144.266 681.706 143.973Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.185 243.372C869.185 243.079 869.432 242.831 869.725 242.831C870.017 242.831 870.265 243.079 870.265 243.372C870.265 243.664 870.017 243.912 869.725 243.912C869.432 243.912 869.185 243.664 869.185 243.372Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.524 235.512C910.524 235.219 910.772 234.972 911.064 234.972C911.357 234.972 911.604 235.219 911.604 235.512C911.604 235.805 911.357 236.053 911.064 236.053C910.772 236.053 910.524 235.805 910.524 235.512Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.524 257.561C910.524 257.268 910.772 257.02 911.064 257.02C911.357 257.02 911.604 257.268 911.604 257.561C911.604 257.854 911.357 258.102 911.064 258.102C910.772 258.102 910.524 257.854 910.524 257.561Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.275 272.971C933.275 272.678 933.523 272.431 933.815 272.431C934.108 272.431 934.355 272.678 934.355 272.971C934.355 273.264 934.108 273.512 933.815 273.512C933.523 273.512 933.275 273.264 933.275 272.971Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.564 248.102C938.564 247.809 938.812 247.561 939.104 247.561C939.397 247.561 939.644 247.809 939.644 248.102C939.644 248.395 939.397 248.643 939.104 248.643C938.812 248.643 938.564 248.395 938.564 248.102Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.957 342.614C914.957 342.321 915.205 342.073 915.498 342.073C915.79 342.073 916.038 342.321 916.038 342.614C916.038 342.907 915.79 343.154 915.498 343.154C915.205 343.154 914.957 342.907 914.957 342.614Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.15 313.942C916.15 313.649 916.398 313.401 916.69 313.401C916.983 313.401 917.23 313.649 917.23 313.942C917.23 314.235 916.983 314.482 916.69 314.482C916.398 314.482 916.15 314.235 916.15 313.942Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.333 311.776C934.333 311.483 934.581 311.235 934.873 311.235C935.166 311.235 935.413 311.483 935.413 311.776C935.413 312.069 935.166 312.316 934.873 312.316C934.581 312.316 934.333 312.069 934.333 311.776Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.265 375.79C902.265 375.497 902.513 375.249 902.805 375.249C903.098 375.249 903.346 375.497 903.346 375.79C903.346 376.082 903.098 376.33 902.805 376.33C902.513 376.33 902.265 376.082 902.265 375.79Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.33 341.012C884.33 340.719 884.577 340.472 884.87 340.472C885.162 340.472 885.41 340.719 885.41 341.012C885.41 341.305 885.162 341.553 884.87 341.553C884.577 341.553 884.33 341.305 884.33 341.012Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.56 291.844C1057.56 291.551 1057.81 291.304 1058.1 291.304C1058.4 291.304 1058.64 291.551 1058.64 291.844C1058.64 292.137 1058.4 292.385 1058.1 292.385C1057.81 292.385 1057.56 292.137 1057.56 291.844Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.04 258.62C1069.04 258.327 1069.29 258.079 1069.58 258.079C1069.87 258.079 1070.12 258.327 1070.12 258.62C1070.12 258.912 1069.87 259.16 1069.58 259.16C1069.29 259.16 1069.04 258.912 1069.04 258.62Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.91 305.899C1074.91 305.606 1075.16 305.358 1075.45 305.358C1075.75 305.358 1075.99 305.606 1075.99 305.899C1075.99 306.192 1075.75 306.439 1075.45 306.439C1075.16 306.439 1074.91 306.192 1074.91 305.899Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.91 142.42C1045.91 142.128 1046.15 141.88 1046.45 141.88C1046.74 141.88 1046.99 142.128 1046.99 142.42C1046.99 142.713 1046.74 142.961 1046.45 142.961C1046.15 142.961 1045.91 142.713 1045.91 142.42Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.63 99.895C1064.63 99.6022 1064.88 99.3544 1065.17 99.3544C1065.46 99.3544 1065.71 99.6022 1065.71 99.895C1065.71 100.188 1065.46 100.436 1065.17 100.436C1064.88 100.436 1064.63 100.188 1064.63 99.895Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.64 66.6489C1054.64 66.3561 1054.89 66.1083 1055.18 66.1083C1055.47 66.1083 1055.72 66.3561 1055.72 66.6489C1055.72 66.9417 1055.47 67.1895 1055.18 67.1895C1054.89 67.1895 1054.64 66.9417 1054.64 66.6489Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.17 31.3091C1065.17 31.0162 1065.42 30.7685 1065.71 30.7685C1066 30.7685 1066.25 31.0162 1066.25 31.3091C1066.25 31.6019 1066 31.8496 1065.71 31.8496C1065.42 31.8496 1065.17 31.6019 1065.17 31.3091Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.37 54.1489C1074.37 53.8561 1074.62 53.6083 1074.91 53.6083C1075.21 53.6083 1075.45 53.8561 1075.45 54.1489C1075.45 54.4417 1075.21 54.6895 1074.91 54.6895C1074.62 54.6895 1074.37 54.4417 1074.37 54.1489Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.91 86.6977C1045.91 86.4049 1046.15 86.1571 1046.45 86.1571C1046.74 86.1571 1046.99 86.4049 1046.99 86.6977C1046.99 86.9905 1046.74 87.2383 1046.45 87.2383C1046.15 87.2383 1045.91 86.9905 1045.91 86.6977Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.83 63.6996C1032.83 63.4068 1033.08 63.1591 1033.37 63.1591C1033.66 63.1591 1033.91 63.4068 1033.91 63.6996C1033.91 63.9925 1033.66 64.2402 1033.37 64.2402C1033.08 64.2402 1032.83 63.9925 1032.83 63.6996Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.71 100.413C866.71 100.12 866.957 99.872 867.25 99.872C867.542 99.872 867.79 100.12 867.79 100.413C867.79 100.705 867.542 100.953 867.25 100.953C866.957 100.953 866.71 100.705 866.71 100.413Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.286 30.1606C877.286 29.8678 877.534 29.62 877.826 29.62C878.119 29.62 878.366 29.8678 878.366 30.1606C878.366 30.4534 878.119 30.7012 877.826 30.7012C877.534 30.7012 877.286 30.4534 877.286 30.1606Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.24 112.555C1010.24 112.262 1010.49 112.015 1010.78 112.015C1011.07 112.015 1011.32 112.262 1011.32 112.555C1011.32 112.848 1011.07 113.096 1010.78 113.096C1010.49 113.096 1010.24 112.848 1010.24 112.555Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.42 433.924C1046.42 433.631 1046.67 433.384 1046.96 433.384C1047.26 433.384 1047.5 433.631 1047.5 433.924C1047.5 434.217 1047.26 434.465 1046.96 434.465C1046.67 434.465 1046.42 434.217 1046.42 433.924Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.86 460.795C1073.86 460.503 1074.1 460.255 1074.4 460.255C1074.69 460.255 1074.94 460.503 1074.94 460.795C1074.94 461.088 1074.69 461.336 1074.4 461.336C1074.1 461.336 1073.86 461.088 1073.86 460.795Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.16 463.498C1025.16 463.206 1025.41 462.958 1025.7 462.958C1025.99 462.958 1026.24 463.206 1026.24 463.498C1026.24 463.791 1025.99 464.039 1025.7 464.039C1025.41 464.039 1025.16 463.791 1025.16 463.498Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.38 488.051C991.38 487.758 991.628 487.511 991.92 487.511C992.213 487.511 992.46 487.758 992.46 488.051C992.46 488.344 992.213 488.592 991.92 488.592C991.628 488.592 991.38 488.344 991.38 488.051Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.3 451.649C990.3 451.356 990.547 451.108 990.84 451.108C991.132 451.108 991.38 451.356 991.38 451.649C991.38 451.942 991.132 452.189 990.84 452.189C990.547 452.189 990.3 451.942 990.3 451.649Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.07 431.448C1004.07 431.155 1004.32 430.907 1004.61 430.907C1004.91 430.907 1005.15 431.155 1005.15 431.448C1005.15 431.741 1004.91 431.988 1004.61 431.988C1004.32 431.988 1004.07 431.741 1004.07 431.448Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.586 487.508C922.586 487.215 922.834 486.968 923.126 486.968C923.419 486.968 923.666 487.215 923.666 487.508C923.666 487.801 923.419 488.049 923.126 488.049C922.834 488.049 922.586 487.801 922.586 487.508Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.826 453.543C877.826 453.251 878.074 453.003 878.367 453.003C878.659 453.003 878.907 453.251 878.907 453.543C878.907 453.836 878.659 454.084 878.367 454.084C878.074 454.084 877.826 453.836 877.826 453.543Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.586 481.631C858.586 481.338 858.833 481.091 859.126 481.091C859.418 481.091 859.666 481.338 859.666 481.631C859.666 481.924 859.418 482.172 859.126 482.172C858.833 482.172 858.586 481.924 858.586 481.631Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.286 443.409C829.286 443.116 829.533 442.868 829.826 442.868C830.118 442.868 830.366 443.116 830.366 443.409C830.366 443.701 830.118 443.949 829.826 443.949C829.533 443.949 829.286 443.701 829.286 443.409Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.447 454.061C808.447 453.768 808.695 453.52 808.987 453.52C809.28 453.52 809.527 453.768 809.527 454.061C809.527 454.354 809.28 454.602 808.987 454.602C808.695 454.602 808.447 454.354 808.447 454.061Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.545 443.946C782.545 443.653 782.793 443.405 783.085 443.405C783.378 443.405 783.625 443.653 783.625 443.946C783.625 444.239 783.378 444.486 783.085 444.486C782.793 444.486 782.545 444.239 782.545 443.946Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.157 476.944C762.157 476.651 762.405 476.403 762.697 476.403C762.99 476.403 763.237 476.651 763.237 476.944C763.237 477.237 762.99 477.484 762.697 477.484C762.405 477.484 762.157 477.237 762.157 476.944Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.724 249.364C741.724 249.071 741.971 248.823 742.264 248.823C742.557 248.823 742.804 249.071 742.804 249.364C742.804 249.657 742.557 249.904 742.264 249.904C741.971 249.904 741.724 249.657 741.724 249.364Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.558 210.782C767.558 210.489 767.805 210.241 768.098 210.241C768.39 210.241 768.638 210.489 768.638 210.782C768.638 211.074 768.39 211.322 768.098 211.322C767.805 211.322 767.558 211.074 767.558 210.782Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.086 185.215C799.086 184.922 799.333 184.675 799.626 184.675C799.918 184.675 800.166 184.922 800.166 185.215C800.166 185.508 799.918 185.756 799.626 185.756C799.333 185.756 799.086 185.508 799.086 185.215Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.028 168.211C782.028 167.919 782.275 167.671 782.568 167.671C782.86 167.671 783.108 167.919 783.108 168.211C783.108 168.504 782.86 168.752 782.568 168.752C782.275 168.752 782.028 168.504 782.028 168.211Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.343 193.098C766.343 192.805 766.59 192.558 766.883 192.558C767.175 192.558 767.423 192.805 767.423 193.098C767.423 193.391 767.175 193.639 766.883 193.639C766.59 193.639 766.343 193.391 766.343 193.098Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.292 196.815C730.292 196.522 730.539 196.274 730.832 196.274C731.124 196.274 731.372 196.522 731.372 196.815C731.372 197.108 731.124 197.355 730.832 197.355C730.539 197.355 730.292 197.108 730.292 196.815Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.984 168.727C726.984 168.434 727.231 168.186 727.524 168.186C727.816 168.186 728.064 168.434 728.064 168.727C728.064 169.02 727.816 169.268 727.524 169.268C727.231 169.268 726.984 169.02 726.984 168.727Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.206 142.42C741.206 142.128 741.454 141.88 741.746 141.88C742.039 141.88 742.286 142.128 742.286 142.42C742.286 142.713 742.039 142.961 741.746 142.961C741.454 142.961 741.206 142.713 741.206 142.42Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.157 276.37C762.157 276.077 762.405 275.829 762.697 275.829C762.99 275.829 763.237 276.077 763.237 276.37C763.237 276.662 762.99 276.91 762.697 276.91C762.405 276.91 762.157 276.662 762.157 276.37Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.626 256.502C680.626 256.21 680.873 255.962 681.166 255.962C681.459 255.962 681.706 256.21 681.706 256.502C681.706 256.795 681.459 257.043 681.166 257.043C680.873 257.043 680.626 256.795 680.626 256.502Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.806 271.752C664.806 271.46 665.053 271.212 665.346 271.212C665.638 271.212 665.886 271.46 665.886 271.752C665.886 272.045 665.638 272.293 665.346 272.293C665.053 272.293 664.806 272.045 664.806 271.752Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.253 243.372C631.253 243.079 631.5 242.831 631.793 242.831C632.086 242.831 632.333 243.079 632.333 243.372C632.333 243.664 632.086 243.912 631.793 243.912C631.5 243.912 631.253 243.664 631.253 243.372Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.989 347.524C595.989 347.231 596.237 346.983 596.53 346.983C596.822 346.983 597.07 347.231 597.07 347.524C597.07 347.817 596.822 348.064 596.53 348.064C596.237 348.064 595.989 347.817 595.989 347.524Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.198 303.645C529.198 303.352 529.446 303.104 529.738 303.104C530.031 303.104 530.278 303.352 530.278 303.645C530.278 303.938 530.031 304.186 529.738 304.186C529.446 304.186 529.198 303.938 529.198 303.645Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.658 332.139C528.658 331.846 528.905 331.599 529.198 331.599C529.491 331.599 529.738 331.846 529.738 332.139C529.738 332.432 529.491 332.68 529.198 332.68C528.905 332.68 528.658 332.432 528.658 332.139Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.183 411.782C526.183 411.489 526.43 411.241 526.723 411.241C527.016 411.241 527.263 411.489 527.263 411.782C527.263 412.075 527.016 412.322 526.723 412.322C526.43 412.322 526.183 412.075 526.183 411.782Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.082 483.813C566.082 483.52 566.329 483.272 566.622 483.272C566.914 483.272 567.162 483.52 567.162 483.813C567.162 484.106 566.914 484.354 566.622 484.354C566.329 484.354 566.082 484.106 566.082 483.813Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.254 488.59C537.254 488.297 537.502 488.05 537.794 488.05C538.087 488.05 538.335 488.297 538.335 488.59C538.335 488.883 538.087 489.131 537.794 489.131C537.502 489.131 537.254 488.883 537.254 488.59Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 370.362C252.784 370.069 253.032 369.821 253.324 369.821C253.617 369.821 253.864 370.069 253.864 370.362C253.864 370.655 253.617 370.902 253.324 370.902C253.032 370.902 252.784 370.655 252.784 370.362Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87 400.295C241.87 400.003 242.117 399.755 242.41 399.755C242.702 399.755 242.95 400.003 242.95 400.295C242.95 400.588 242.702 400.836 242.41 400.836C242.117 400.836 241.87 400.588 241.87 400.295Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.225 397.211C270.225 396.919 270.472 396.671 270.765 396.671C271.058 396.671 271.305 396.919 271.305 397.211C271.305 397.504 271.058 397.752 270.765 397.752C270.472 397.752 270.225 397.504 270.225 397.211Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43 444.465C240.43 444.172 240.678 443.925 240.97 443.925C241.263 443.925 241.51 444.172 241.51 444.465C241.51 444.758 241.263 445.006 240.97 445.006C240.678 445.006 240.43 444.758 240.43 444.465Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.06 199.766C1037.06 199.473 1037.31 199.226 1037.6 199.226C1037.9 199.226 1038.14 199.473 1038.14 199.766C1038.14 200.059 1037.9 200.307 1037.6 200.307C1037.31 200.307 1037.06 200.059 1037.06 199.766Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.55 258.081C1036.55 257.788 1036.79 257.54 1037.09 257.54C1037.38 257.54 1037.63 257.788 1037.63 258.081C1037.63 258.373 1037.38 258.621 1037.09 258.621C1036.79 258.621 1036.55 258.373 1036.55 258.081Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.05 337.387C1057.05 337.094 1057.29 336.847 1057.59 336.847C1057.88 336.847 1058.13 337.094 1058.13 337.387C1058.13 337.68 1057.88 337.928 1057.59 337.928C1057.29 337.928 1057.05 337.68 1057.05 337.387Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.397 415.635C804.397 415.342 804.644 415.095 804.937 415.095C805.229 415.095 805.477 415.342 805.477 415.635C805.477 415.928 805.229 416.176 804.937 416.176C804.644 416.176 804.397 415.928 804.397 415.635Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.827 246.885C790.827 246.592 791.074 246.345 791.367 246.345C791.659 246.345 791.907 246.592 791.907 246.885C791.907 247.178 791.659 247.426 791.367 247.426C791.074 247.426 790.827 247.178 790.827 246.885Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.989 291.842C325.989 291.167 326.529 290.626 327.204 290.626C327.879 290.626 328.419 291.167 328.419 291.842C328.419 292.518 327.879 293.059 327.204 293.059C326.529 293.059 325.989 292.518 325.989 291.842Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.036 248.104C280.036 247.428 280.576 246.888 281.252 246.888C281.927 246.888 282.467 247.428 282.467 248.104C282.467 248.78 281.927 249.32 281.252 249.32C280.576 249.32 280.036 248.78 280.036 248.104Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.145 76.6724C301.145 75.9967 301.685 75.4561 302.36 75.4561C303.035 75.4561 303.575 75.9967 303.575 76.6724C303.575 77.3481 303.035 77.8887 302.36 77.8887C301.685 77.8887 301.145 77.3481 301.145 76.6724Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2114 182.784C38.2114 182.108 38.7515 181.567 39.4266 181.567C40.1017 181.567 40.6418 182.108 40.6418 182.784C40.6418 183.459 40.1017 184 39.4266 184C38.7515 184 38.2114 183.459 38.2114 182.784Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.533 258.081C106.533 257.405 107.073 256.864 107.748 256.864C108.423 256.864 108.963 257.405 108.963 258.081C108.963 258.756 108.423 259.297 107.748 259.297C107.073 259.297 106.533 258.756 106.533 258.081Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43 319.862C89.43 319.186 89.9701 318.646 90.6452 318.646C91.3203 318.646 91.8604 319.186 91.8604 319.862C91.8604 320.538 91.3203 321.078 90.6452 321.078C89.9701 321.078 89.43 320.538 89.43 319.862Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.498 327.387C169.498 326.712 170.038 326.171 170.713 326.171C171.388 326.171 171.928 326.712 171.928 327.387C171.928 328.063 171.388 328.604 170.713 328.604C170.038 328.604 169.498 328.063 169.498 327.387Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.242 387.547C163.242 386.872 163.782 386.331 164.457 386.331C165.132 386.331 165.673 386.872 165.673 387.547C165.673 388.223 165.132 388.764 164.457 388.764C163.782 388.764 163.242 388.223 163.242 387.547Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54155 431.967C9.54155 431.292 10.0816 430.751 10.7567 430.751C11.4318 430.751 11.9719 431.292 11.9719 431.967C11.9719 432.643 11.4318 433.184 10.7567 433.184C10.0816 433.184 9.54155 432.643 9.54155 431.967Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.091 416.692C549.091 416.016 549.631 415.476 550.307 415.476C550.982 415.476 551.522 416.016 551.522 416.692C551.522 417.368 550.982 417.908 550.307 417.908C549.631 417.908 549.091 417.368 549.091 416.692Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.775 439.848C523.775 439.172 524.315 438.632 524.99 438.632C525.665 438.632 526.205 439.172 526.205 439.848C526.205 440.524 525.665 441.064 524.99 441.064C524.315 441.064 523.775 440.524 523.775 439.848Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.486 451.649C653.486 450.973 654.026 450.433 654.701 450.433C655.377 450.433 655.917 450.973 655.917 451.649C655.917 452.325 655.377 452.865 654.701 452.865C654.026 452.865 653.486 452.325 653.486 451.649Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.516 294.342C682.516 293.667 683.056 293.126 683.731 293.126C684.407 293.126 684.947 293.667 684.947 294.342C684.947 295.018 684.407 295.559 683.731 295.559C683.056 295.559 682.516 295.018 682.516 294.342Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.323 392.458C752.323 391.782 752.863 391.241 753.538 391.241C754.213 391.241 754.753 391.782 754.753 392.458C754.753 393.133 754.213 393.674 753.538 393.674C752.863 393.674 752.323 393.133 752.323 392.458Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.272 489.108C732.272 488.432 732.812 487.892 733.487 487.892C734.162 487.892 734.703 488.432 734.703 489.108C734.703 489.784 734.162 490.324 733.487 490.324C732.812 490.324 732.272 489.784 732.272 489.108Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.247 482.237C492.247 481.561 492.787 481.021 493.462 481.021C494.137 481.021 494.677 481.561 494.677 482.237C494.677 482.913 494.137 483.453 493.462 483.453C492.787 483.453 492.247 482.913 492.247 482.237Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.359 474.514C396.359 473.838 396.899 473.298 397.574 473.298C398.249 473.298 398.789 473.838 398.789 474.514C398.789 475.19 398.249 475.73 397.574 475.73C396.899 475.73 396.359 475.19 396.359 474.514Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.695 339.795C856.695 339.12 857.235 338.579 857.911 338.579C858.586 338.579 859.126 339.12 859.126 339.795C859.126 340.471 858.586 341.012 857.911 341.012C857.235 341.012 856.695 340.471 856.695 339.795Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.509 272.971C836.509 272.295 837.049 271.755 837.724 271.755C838.4 271.755 838.94 272.295 838.94 272.971C838.94 273.647 838.4 274.187 837.724 274.187C837.049 274.187 836.509 273.647 836.509 272.971Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.351 223.237C724.351 222.358 725.071 221.638 725.948 221.638C726.826 221.638 727.546 222.358 727.546 223.237C727.546 224.115 726.826 224.836 725.948 224.836C725.071 224.836 724.351 224.115 724.351 223.237Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.282 342.614C969.282 341.735 970.002 341.015 970.879 341.015C971.757 341.015 972.477 341.735 972.477 342.614C972.477 343.492 971.757 344.213 970.879 344.213C970.002 344.213 969.282 343.492 969.282 342.614Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.93 440.231C1020.93 439.352 1021.65 438.632 1022.53 438.632C1023.4 438.632 1024.12 439.352 1024.12 440.231C1024.12 441.109 1023.4 441.83 1022.53 441.83C1021.65 441.83 1020.93 441.109 1020.93 440.231Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.09 441.807C945.09 440.929 945.81 440.208 946.688 440.208C947.565 440.208 948.285 440.929 948.285 441.807C948.285 442.685 947.565 443.406 946.688 443.406C945.81 443.406 945.09 442.685 945.09 441.807Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.353 65.1176C122.353 64.2392 123.073 63.5184 123.951 63.5184C124.828 63.5184 125.548 64.2392 125.548 65.1176C125.548 65.996 124.828 66.7168 123.951 66.7168C123.073 66.7168 122.353 65.996 122.353 65.1176Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06 65.1176C376.06 64.2392 376.78 63.5184 377.658 63.5184C378.535 63.5184 379.255 64.2392 379.255 65.1176C379.255 65.996 378.535 66.7168 377.658 66.7168C376.78 66.7168 376.06 65.996 376.06 65.1176Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.848 76.6723C884.848 75.7939 885.568 75.0731 886.445 75.0731C887.323 75.0731 888.043 75.7939 888.043 76.6723C888.043 77.5507 887.323 78.2715 886.445 78.2715C885.568 78.2715 884.848 77.5507 884.848 76.6723Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4932 197.332C94.4932 196.454 95.2133 195.733 96.0909 195.733C96.9686 195.733 97.6887 196.454 97.6887 197.332C97.6887 198.211 96.9686 198.932 96.0909 198.932C95.2133 198.932 94.4932 198.211 94.4932 197.332Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.35 7.86173C1033.35 6.98329 1034.07 6.26251 1034.95 6.26251C1035.83 6.26251 1036.55 6.98329 1036.55 7.86173C1036.55 8.74016 1035.83 9.46094 1034.95 9.46094C1034.07 9.46094 1033.35 8.74016 1033.35 7.86173Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.009 55.7484C578.009 54.87 578.729 54.1493 579.607 54.1493C580.484 54.1493 581.204 54.87 581.204 55.7484C581.204 56.6269 580.484 57.3477 579.607 57.3477C578.729 57.3477 578.009 56.6269 578.009 55.7484Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.178 195.215C467.178 194.337 467.898 193.616 468.776 193.616C469.653 193.616 470.373 194.337 470.373 195.215C470.373 196.094 469.653 196.814 468.776 196.814C467.898 196.814 467.178 196.094 467.178 195.215Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.697 115.209C762.697 114.331 763.417 113.61 764.295 113.61C765.173 113.61 765.893 114.331 765.893 115.209C765.893 116.088 765.173 116.809 764.295 116.809C763.417 116.809 762.697 116.088 762.697 115.209Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.45 145.436C1075.45 144.76 1075.99 144.22 1076.67 144.22C1077.34 144.22 1077.88 144.76 1077.88 145.436C1077.88 146.112 1077.34 146.652 1076.67 146.652C1075.99 146.652 1075.45 146.112 1075.45 145.436Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.082 166.454C749.082 165.778 749.622 165.237 750.298 165.237C750.973 165.237 751.513 165.778 751.513 166.454C751.513 167.129 750.973 167.67 750.298 167.67C749.622 167.67 749.082 167.129 749.082 166.454Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.832 301.19C730.832 300.514 731.372 299.974 732.047 299.974C732.722 299.974 733.262 300.514 733.262 301.19C733.262 301.866 732.722 302.406 732.047 302.406C731.372 302.406 730.832 301.866 730.832 301.19Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.702 223.235C654.702 222.559 655.242 222.019 655.917 222.019C656.592 222.019 657.132 222.559 657.132 223.235C657.132 223.911 656.592 224.451 655.917 224.451C655.242 224.451 654.702 223.911 654.702 223.235Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.695 452.325C554.695 451.649 555.235 451.108 555.91 451.108C556.585 451.108 557.125 451.649 557.125 452.325C557.125 453 556.585 453.541 555.91 453.541C555.235 453.541 554.695 453 554.695 452.325Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.441 352.206C502.441 351.53 502.981 350.989 503.656 350.989C504.331 350.989 504.871 351.53 504.871 352.206C504.871 352.881 504.331 353.422 503.656 353.422C502.981 353.422 502.441 352.881 502.441 352.206Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.511 127.983C607.511 127.307 608.051 126.767 608.726 126.767C609.401 126.767 609.942 127.307 609.942 127.983C609.942 128.659 609.401 129.199 608.726 129.199C608.051 129.199 607.511 128.659 607.511 127.983Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.294 25.9927C954.294 25.317 954.834 24.7764 955.509 24.7764C956.184 24.7764 956.724 25.317 956.724 25.9927C956.724 26.6684 956.184 27.209 955.509 27.209C954.834 27.209 954.294 26.6684 954.294 25.9927Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.86 49.8677C766.86 49.192 767.4 48.6514 768.076 48.6514C768.751 48.6514 769.291 49.192 769.291 49.8677C769.291 50.5434 768.751 51.084 768.076 51.084C767.4 51.084 766.86 50.5434 766.86 49.8677Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.761 20.7915C815.761 20.1158 816.301 19.5752 816.976 19.5752C817.651 19.5752 818.191 20.1158 818.191 20.7915C818.191 21.4673 817.651 22.0078 816.976 22.0078C816.301 22.0078 815.761 21.4673 815.761 20.7915Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.664 163.953C921.664 163.165 922.316 162.511 923.104 162.511C923.891 162.511 924.544 163.165 924.544 163.953C924.544 164.741 923.891 165.395 923.104 165.395C922.316 165.395 921.664 164.741 921.664 163.953Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.579 274.41C385.579 273.622 386.232 272.968 387.019 272.968C387.807 272.968 388.459 273.622 388.459 274.41C388.459 275.198 387.807 275.852 387.019 275.852C386.232 275.852 385.579 275.198 385.579 274.41Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.664 368.92C413.664 368.131 414.316 367.478 415.104 367.478C415.891 367.478 416.544 368.131 416.544 368.92C416.544 369.708 415.891 370.361 415.104 370.361C414.316 370.361 413.664 369.708 413.664 368.92Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.529 249.318C239.529 248.53 240.182 247.877 240.97 247.877C241.757 247.877 242.41 248.53 242.41 249.318C242.41 250.107 241.757 250.76 240.97 250.76C240.182 250.76 239.529 250.107 239.529 249.318Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.641 79.6698C262.641 78.8815 263.294 78.2283 264.081 78.2283C264.869 78.2283 265.522 78.8815 265.522 79.6698C265.522 80.4581 264.869 81.1113 264.081 81.1113C263.294 81.1113 262.641 80.4581 262.641 79.6698Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.102 113.996C56.102 113.208 56.7546 112.554 57.5422 112.554C58.3298 112.554 58.9825 113.208 58.9825 113.996C58.9825 114.784 58.3298 115.437 57.5422 115.437C56.7546 115.437 56.102 114.784 56.102 113.996Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.723 142.42C526.723 140.754 528.073 139.425 529.716 139.425C531.359 139.425 532.709 140.776 532.709 142.42C532.709 144.065 531.359 145.416 529.716 145.416C528.073 145.416 526.723 144.065 526.723 142.42Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.307 232.516C987.307 230.849 988.657 229.52 990.3 229.52C991.943 229.52 993.293 230.872 993.293 232.516C993.293 234.16 991.943 235.512 990.3 235.512C988.657 235.512 987.307 234.16 987.307 232.516Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.717 430.907C863.717 429.24 865.067 427.911 866.71 427.911C868.352 427.911 869.703 429.262 869.703 430.907C869.703 432.551 868.352 433.902 866.71 433.902C865.067 433.902 863.717 432.551 863.717 430.907Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.614 246.368C576.614 244.701 577.964 243.372 579.607 243.372C581.25 243.372 582.6 244.723 582.6 246.368C582.6 248.012 581.25 249.363 579.607 249.363C577.964 249.363 576.614 248.012 576.614 246.368Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.928 372.795C560.928 371.129 562.279 369.8 563.921 369.8C565.564 369.8 566.914 371.151 566.914 372.795C566.914 374.44 565.564 375.791 563.921 375.791C562.279 375.791 560.928 374.44 560.928 372.795Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.936 182.782C335.936 181.115 337.286 179.786 338.929 179.786C340.572 179.786 341.922 181.137 341.922 182.782C341.922 184.426 340.572 185.777 338.929 185.777C337.286 185.777 335.936 184.426 335.936 182.782Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.348 344.211C230.348 342.545 231.698 341.216 233.341 341.216C234.984 341.216 236.334 342.567 236.334 344.211C236.334 345.856 234.984 347.207 233.341 347.207C231.698 347.207 230.348 345.856 230.348 344.211Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.122 452.327C116.469 452.327 115.129 453.668 115.129 455.323C115.129 456.977 116.469 458.318 118.122 458.318C119.775 458.318 121.115 456.977 121.115 455.323C121.115 453.668 119.775 452.327 118.122 452.327Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.672 301.19C149.672 299.523 151.022 298.194 152.665 298.194C154.308 298.194 155.658 299.546 155.658 301.19C155.658 302.834 154.308 304.186 152.665 304.186C151.022 304.186 149.672 302.834 149.672 301.19Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.927 449.893C194.927 448.226 196.277 446.897 197.92 446.897C199.563 446.897 200.913 448.249 200.913 449.893C200.913 451.537 199.563 452.889 197.92 452.889C196.277 452.889 194.927 451.537 194.927 449.893Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.744 468.725C834.091 468.725 832.751 470.067 832.751 471.721C832.751 473.376 834.091 474.717 835.744 474.717C837.397 474.717 838.737 473.376 838.737 471.721C838.737 470.067 837.397 468.725 835.744 468.725Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.184 9.43986C670.184 7.7731 671.534 6.44418 673.177 6.44418C674.82 6.44418 676.17 7.79562 676.17 9.43986C676.17 11.0841 674.82 12.4355 673.177 12.4355C671.534 12.4355 670.184 11.0841 670.184 9.43986Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.59 470.502C1004.59 468.836 1005.94 467.507 1007.58 467.507C1009.23 467.507 1010.58 468.858 1010.58 470.502C1010.58 472.147 1009.23 473.498 1007.58 473.498C1005.94 473.498 1004.59 472.147 1004.59 470.502Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.515 458.319C332.515 456.652 333.866 455.323 335.508 455.323C337.151 455.323 338.501 456.675 338.501 458.319C338.501 459.963 337.151 461.314 335.508 461.314C333.866 461.314 332.515 459.963 332.515 458.319Z",
    fill: "#FFFAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8996 82.6196C71.8996 80.9528 73.2497 79.6239 74.8925 79.6239C76.5353 79.6239 77.8856 80.9753 77.8856 82.6196C77.8856 84.2638 76.5353 85.6152 74.8925 85.6152C73.2497 85.6152 71.8996 84.2638 71.8996 82.6196Z",
    fill: "#FFFAEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(811.26 320.969) rotate(-180) scale(12.9397 12.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5246 470.863) rotate(-180) scale(12.9397 12.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4867 319.706) rotate(-180) scale(12.9397 12.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(876.701 292.926) rotate(-180) scale(12.9397 12.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254 162.446) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(691.315 472.17) rotate(-180) scale(6.50358 6.50941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1055.85 481.539) rotate(-180) scale(6.50358 6.50941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(409.433 472.801) rotate(-180) scale(6.50358 6.50941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(831.108 356.825) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3678 366.198) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.4291 45.0961) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(983.797 73.1625) rotate(-180) scale(6.50359 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(977.36 398.967) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(567.274 318.555) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.35 399.598) rotate(-180) scale(6.50358 6.50941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.064 327.928) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.687 420.252) rotate(-180) scale(6.50358 6.5094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_172_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.252 63.6991) rotate(-180) scale(12.9397 12.9512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_3448"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 491,
    width: 1080,
    height: 886,
    rx: 360,
    transform: "rotate(-180 1080 491)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2211ccb250036f8270e6464cf586a34b.svg";
export { ForwardRef as ReactComponent };